import styled from "styled-components";

export const OutlookVersionWrapper = styled.div`
  padding-top: ${(props) => props.theme.spacing.normal};
  border-top: 1px solid ${(props) => props.theme.colors.primary.lightest};
  display: flex;
  justify-content: space-between;
  margin-top: ${(props) => props.theme.spacing.large};
  margin-inline: ${(props) => props.theme.spacing.normal};
`;

export const OutlookNoPermission = styled.p`
  opacity: 0.33;
  padding-left: ${(props) => props.theme.spacing.normal};
  padding-top: ${(props) => props.theme.spacing.normal};
`;
